import Object1 from './objects/1'
import Object2 from './objects/2'
import Object3 from './objects/3'
import Object4 from './objects/4'
import Object5 from './objects/5'
import Object6 from './objects/6'
import Object7 from './objects/7'
import Object8 from './objects/8'

import Points from './objects/points'

import { screens } from '../../sections/constants'
import { events } from './constants'

class Controller {
    preloader: any
    wave: any
    galaxy: any
    torus: any
    terrain: any
    sphere: any
    sphereBottom: any
    product: any
    points: any

    state = {
        active: screens.NONE
    }
    controllerContext

    constructor(scene, canvas, controllerContext) {
        this.controllerContext = controllerContext
        this.state.active = this.controllerContext.active
        this.preloader = new Object1(scene)
        this.wave = new Object2(scene, canvas)
        this.galaxy = new Object3(scene)
        this.torus = new Object4(scene)
        this.product = new Object5(scene)
        this.terrain = new Object6(scene)
        this.sphere = new Object7(scene)
        this.sphereBottom = new Object8(scene)
        this.points = new Points(scene)
        this.statechange()
    }

    statechange() {
        document.addEventListener(events.STATECHANGE, this.listener)
    }
    listener = function(e) {
        const id = e.detail.id
        if ( !Object.values(screens).includes(id) ) { console.error('[SCENE:CONTROLLER]: screen not found'); return }
        this.state.active = id
    }.bind(this)

    render() {
        const notRender = (array = []) => {
            array.forEach(_ => _.render({ visible: false }))
        }
        const render = (array = []) => {
            array.forEach(_ => _.render({ visible: true }))
        }
        const renderPoints = ( screen, opacity, x, y, z ) => {
            this.points.render({ screen, opacity, x, y, z })
        }
        const moveGalaxyTo = ( screen ) => {
            this.galaxy.render({ visible: false, screen })
        }
        const destroyLoader = () => {
            this.preloader.render({ destroy: true })
        }

        switch( this.state.active ) {
            case screens.NONE:
                this.preloader.render({})
                break;


            case screens.HERO:
                destroyLoader()
                render([ this.wave ])
                renderPoints( screens.HERO, 1, 0, 0, 0 )
                notRender([ this.galaxy, this.torus, this.terrain, this.sphere, this.sphereBottom, this.product ])
                break;


            case screens.SITEMAP:
                destroyLoader()
                render([ this.galaxy ])
                renderPoints( screens.SITEMAP, 0, 0, 0, 10 )
                this.galaxy.controls()
                notRender([this.wave, this.torus, this.terrain, this.sphere, this.sphereBottom, this.product])
                break;


            case screens.PARTNERS:
                destroyLoader()
                moveGalaxyTo(screens.PARTNERS)
                render([ this.torus ])
                renderPoints( screens.PARTNERS, 1, 0, 0, 0 )
                this.torus.controls()
                notRender([this.wave, this.terrain, this.sphere, this.sphereBottom, this.product])
                break;


            case screens.ROADMAP:
                destroyLoader()
                moveGalaxyTo(screens.ROADMAP)
                render([ this.terrain ])
                renderPoints( screens.ROADMAP, 1, 0, 3, 0 )
                notRender([this.wave, this.torus, this.sphere, this.sphereBottom, this.product])
                break;
            case screens.ROADMAP__INNER_1:
                destroyLoader()
                renderPoints( screens.ROADMAP__INNER_1, 1, 0, 3, 0 )
                this.terrain.render({ visible: true, move: 0 })
                notRender([this.wave, this.torus, this.sphere, this.sphereBottom, this.product])
                break;
            case screens.ROADMAP__INNER_2:
                destroyLoader()
                renderPoints( screens.ROADMAP__INNER_2, 1, -1, 2.5, 2 )
                this.terrain.render({ visible: true, move: 1 })
                notRender([this.wave, this.torus, this.sphere, this.sphereBottom, this.product])
                break;
            case screens.ROADMAP__INNER_3:
                destroyLoader()
                renderPoints( screens.ROADMAP__INNER_3, 1, 1, 2.5, 2 )
                this.terrain.render({ visible: true, move: 2 })
                notRender([this.wave, this.torus, this.sphere, this.sphereBottom, this.product])
                break;


            case screens.INVESTORS:
                destroyLoader()
                moveGalaxyTo(screens.INVESTORS)
                render([ this.sphere ])
                renderPoints( screens.INVESTORS, 1, 2.5, 0, 0 )
                notRender([this.wave, this.torus, this.terrain, this.sphereBottom, this.product])
                break;


            case screens.SOCIAL:
                destroyLoader()
                moveGalaxyTo(screens.SOCIAL)
                render([ this.sphereBottom ])
                renderPoints( screens.SOCIAL, 1, 0, 2, 0 )
                notRender([this.wave, this.torus, this.terrain, this.sphere, this.product])
                break;

                
            case screens.PRODUCT:
                destroyLoader()
                this.product.render({ visible: true, move: 0 })
                moveGalaxyTo(screens.PRODUCT)
                renderPoints( screens.PRODUCT, 1, 0, 0, 0 )
                notRender([this.wave, this.torus, this.terrain, this.sphere, this.sphereBottom])
                break;
            case screens.PRODUCT__INNER_1:
                destroyLoader()
                this.product.render({ visible: true, move: 1 })
                renderPoints( screens.PRODUCT__INNER_1, 1, 0, 0, 0 )
                notRender([this.wave, this.torus, this.terrain, this.sphere, this.sphereBottom])
                break;
            case screens.PRODUCT__INNER_2:
                destroyLoader()
                this.product.render({ visible: true, move: 2 })
                renderPoints( screens.PRODUCT__INNER_2, 1, 0, 0, 1 )
                notRender([this.wave, this.torus, this.terrain, this.sphere, this.sphereBottom])
                break;


            default:;
        }
    }

    resize() {
        this.preloader.resize()
        this.galaxy.resize()
        this.torus.resize()
        this.sphere.resize()
        this.points.resize()
        this.product.resize()
    }

    unmount() {
        document.removeEventListener('statechange', this.listener)
    }
}

export default Controller